import PageWrapperComponent from "@src/components/organisms/page-wrapper/page-wrapper.component";
import FeatherIcon from "feather-icons-react";
import PageHeadComponent from "@src/components/organisms/page-head/page-head.component";
import { Card, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

function SiteSettingsListTemplateComponent({
  templateModal: {
    tableTitle,
    keyColumn,
    breadCrumbs,
    tableColumn,
    tableData,
    totalCount,
    filters,
    tableParams,
  },
  templateEvents: {
    getCustomerData,
    handleCreateClick,
    deleteRecords,
    submitFilter,
  },
}) {
  const settingFormEdit = `${breadCrumbs[0].menu_url}/edit`;

  return (
    <PageWrapperComponent>
      <PageHeadComponent
        title={"Site Settings"}
        breadCrumbs={breadCrumbs}
        actionContent={
          (!tableData || tableData.length === 0) && (
            <Button
              variant="primary"
              size="sm"
              onClick={handleCreateClick}
              className="d-flex align-items-center"
            >
              <FeatherIcon icon="plus" size={16} className="me-1" />
              Add New Settings
            </Button>
          )
        }
      />

      <Row className="mt-1">
        {tableData?.map((item) => (
          <Col className="mx-auto" key={item.id}>
            <Card className="shadow-sm mb-4">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h4 className="mb-0">Site Information</h4>
                  <div>
                    <Link
                      to={{
                        pathname: settingFormEdit,
                        state: { row: item },
                      }}
                      className="btn btn-primary btn-sm me-2"
                    >
                      <FeatherIcon icon="edit-2" size={14} className="me-1" />
                      Edit
                    </Link>
                  </div>
                </div>

                <Row>
                  {/* Left Column - Logos */}
                  <Col md={4} className="border-end">
                    <div className="text-center mb-4">
                      <h6 className="text-muted mb-3">Header Logo</h6>
                      <img
                        src={item.header_logo || "/placeholder-logo.png"}
                        alt="Header Logo"
                        className="img-fluid rounded border p-2"
                        style={{ maxHeight: "120px" }}
                      />
                    </div>
                    <div className="text-center">
                      <h6 className="text-muted mb-3">Footer Logo</h6>
                      <img
                        src={item.footer_logo || "/placeholder-logo.png"}
                        alt="Footer Logo"
                        className="img-fluid rounded border p-2"
                        style={{ maxHeight: "120px" }}
                      />
                    </div>
                  </Col>

                  {/* Right Column - Details */}
                  <Col md={8} className="ps-4">
                    <Row>
                      <Col md={6} className="mb-3">
                        <h6 className="text-muted">Company Name</h6>
                        <p className="mb-0">{item.company_name || "Not set"}</p>
                      </Col>
                      <Col md={6} className="mb-3">
                        <h6 className="text-muted">Contact Email</h6>
                        <p className="mb-0">
                          {item.contact_email || "Not set"}
                        </p>
                      </Col>
                      <Col md={6} className="mb-3">
                        <h6 className="text-muted">Contact Number</h6>
                        <p className="mb-0">
                          {item.contact_number || "Not set"}
                        </p>
                      </Col>
                      <Col md={12} className="mb-3">
                        <h6 className="text-muted">Address</h6>
                        <p className="mb-0">{item.address || "Not set"}</p>
                      </Col>
                      {item.footer_description && (
                        <Col md={12} className="mb-3">
                          <h6 className="text-muted">Footer Description</h6>
                          <p className="mb-0" style={{ fontSize: "0.9rem" }}>
                            {item.footer_description}
                          </p>
                        </Col>
                      )}
                      {item.footer_customer_service && (
                        <Col md={12} className="mb-3">
                          <h6 className="text-muted">Customer Service</h6>
                          <p className="mb-0" style={{ fontSize: "0.9rem" }}>
                            {item.footer_customer_service}
                          </p>
                        </Col>
                      )}

                      <div>
                        <span className="me-3">
                          <FeatherIcon
                            icon="calendar"
                            size={14}
                            className="me-1"
                          />
                          Created at : {item.created_at}
                        </span>
                        <span>
                          <FeatherIcon
                            icon="refresh-cw"
                            size={14}
                            className="me-1"
                          />
                          Updated at : {item.updated_at}
                        </span>
                      </div>
                    </Row>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </PageWrapperComponent>
  );
}

export default SiteSettingsListTemplateComponent;
